// Mock data for CRACK STORE clone

export const PRODUCTS = [
  { id: 'p1', name: 'CHAT GPT PLUS', category: 'AI', icon: 'openai', usdt: 1.0, inr: 100, stock: 4, badgeColor: 'green' },
  { id: 'p2', name: 'CHATGPT PLUS FULL WARRANTY', category: 'AI', icon: 'openai', usdt: 4.0, inr: 400, stock: 0, badgeColor: 'red' },
  { id: 'p3', name: 'LINKEDIN SALES NAVIGATOR 75% OFF 12M', category: 'LinkedIn', icon: 'linkedin', usdt: 5.0, inr: 500, stock: 10, badgeColor: 'green' },
  { id: 'p4', name: 'LINKEDIN BUSINESS 75% OFF 12M', category: 'LinkedIn', icon: 'linkedin', usdt: 5.0, inr: 500, stock: 10, badgeColor: 'green' },
  { id: 'p5', name: 'LINKEDIN CAREER 75% OFF 12 MONTHS', category: 'LinkedIn', icon: 'linkedin', usdt: 5.0, inr: 500, stock: 10, badgeColor: 'green' },
  { id: 'p6', name: 'LINKEDIN ALL IN ONE 75% OFF 12M', category: 'LinkedIn', icon: 'linkedin', usdt: 5.0, inr: 500, stock: 9, badgeColor: 'green' },
  { id: 'p7', name: 'NETFLIX 4K PLAN 1M ON YOUR MAIL', category: 'Streaming', icon: 'netflix', usdt: 2.1, inr: 210, stock: 3, badgeColor: 'amber' },
  { id: 'p8', name: 'NORD VPN 12 MONTHS', category: 'VPN', icon: 'nordvpn', usdt: 10.0, inr: 1000, stock: 2, badgeColor: 'amber' },
  { id: 'p9', name: 'LINKEDIN CAREER 2M', category: 'LinkedIn', icon: 'linkedin', usdt: 2.0, inr: 200, stock: 3, badgeColor: 'amber' },
  { id: 'p10', name: 'AWS 200$/100$ CREDIT ACCOUNT', category: 'Cloud', icon: 'aws', usdt: 8.0, inr: 800, stock: 2, badgeColor: 'amber' },
  { id: 'p11', name: 'LINKEDIN 3 MONTHS --- OLD USER', category: 'LinkedIn', icon: 'linkedin', usdt: 3.0, inr: 300, stock: 2, badgeColor: 'amber' },
  { id: 'p12', name: '3 MONTHS OF NOTION BUSINESS', category: 'Productivity', icon: 'notion', usdt: 1.0, inr: 100, stock: 2, badgeColor: 'amber' },
  { id: 'p13', name: 'NORD VPN 3 MONTHS', category: 'VPN', icon: 'nordvpn', usdt: 2.5, inr: 250, stock: 6, badgeColor: 'green' },
  { id: 'p14', name: 'YOUTUBE PREMIUM - 3 MONTH SUBSCRIPTION', category: 'Streaming', icon: 'youtube', usdt: 1.75, inr: 175, stock: 17, badgeColor: 'green' },
  { id: 'p15', name: 'SPOTIFY PREMIUM 6 MONTHS', category: 'Streaming', icon: 'spotify', usdt: 3.5, inr: 350, stock: 8, badgeColor: 'green' },
  { id: 'p16', name: 'CANVA PRO 12 MONTHS INVITE', category: 'Productivity', icon: 'canva', usdt: 2.0, inr: 200, stock: 15, badgeColor: 'green' },
  { id: 'p17', name: 'GRAMMARLY PREMIUM 12M', category: 'Productivity', icon: 'grammarly', usdt: 3.0, inr: 300, stock: 5, badgeColor: 'green' },
  { id: 'p18', name: 'DISNEY+ 12 MONTH ACCOUNT', category: 'Streaming', icon: 'disney', usdt: 4.5, inr: 450, stock: 3, badgeColor: 'amber' },
  { id: 'p19', name: 'PRIME VIDEO 6M SHARED', category: 'Streaming', icon: 'prime', usdt: 2.25, inr: 225, stock: 0, badgeColor: 'red' },
  { id: 'p20', name: 'EXPRESS VPN 6 MONTHS', category: 'VPN', icon: 'expressvpn', usdt: 4.0, inr: 400, stock: 4, badgeColor: 'green' },
];

export const NAV_ITEMS = [
  { id: 'buy', label: 'Buy Now', code: '01' },
  { id: 'stock', label: 'Stock Status', code: '02' },
  { id: 'orders', label: 'My Orders', code: '03' },
];

export const ACCOUNT_ITEMS = [
  { id: 'wallet', label: 'Wallet', code: '04' },
  { id: 'profile', label: 'Profile', code: '05' },
  { id: 'feedback', label: 'Feedback', code: '06' },
  { id: 'support', label: 'Support', code: '07' },
];

export const MOCK_ORDERS = [
  { id: 'ORD-9021', product: 'NETFLIX 4K PLAN 1M ON YOUR MAIL', amount: 2.1, currency: 'USDT', status: 'DELIVERED', date: '2025-07-12 14:22' },
  { id: 'ORD-9017', product: 'CHAT GPT PLUS', amount: 100, currency: 'INR', status: 'DELIVERED', date: '2025-07-10 09:41' },
  { id: 'ORD-9002', product: 'NORD VPN 12 MONTHS', amount: 10.0, currency: 'USDT', status: 'PROCESSING', date: '2025-07-08 18:03' },
];

export const MOCK_TXNS = [
  { id: 'TXN-4412', type: 'DEPOSIT', amount: 25.0, currency: 'USDT', status: 'CONFIRMED', date: '2025-07-14 10:12' },
  { id: 'TXN-4402', type: 'PURCHASE', amount: -2.1, currency: 'USDT', status: 'SETTLED', date: '2025-07-12 14:22' },
  { id: 'TXN-4381', type: 'DEPOSIT', amount: 500, currency: 'INR', status: 'CONFIRMED', date: '2025-07-09 08:03' },
  { id: 'TXN-4370', type: 'PURCHASE', amount: -100, currency: 'INR', status: 'SETTLED', date: '2025-07-10 09:41' },
];

export const SYSTEM_STATUS = {
  status: 'Operational',
  uptime: '99.98%',
  region: 'IN-BLR',
  version: 'v1.4.2',
};
